// Components
import { Section, useMaxWidth } from '@tracklib/kit'
import QueryTrackList from 'components/staticpages/blocks/querytracklist'

// Hooks
import { useTracking } from 'modules/tracking/hooks'

import styles from './tracklistsblock.css'

type Props = {
  value: {
    compact: boolean
    songlists: []
    showCount: number
  }
}

const TrackListsBlock = ({ value: { compact, songlists, showCount } }: Props): JSX.Element => {
  const trackEvent = useTracking()
  const isSmall = useMaxWidth()
  return (
    <Section>
      <div className={styles.lists}>
        {songlists.map((songlist, index) => {
          const {
            heading,
            heading_mobile,
            query,
            show_more_text,
            show_more_text_mobile,
            show_more_url,
            max_shown,
            max_size,
            two_column,
            random_order,
            identifier,
          } = songlist

          const handleClick = e => {
            const id = identifier || heading || 'no identifier'
            if (e?.target?.dataset?.play) {
              return trackEvent('click entity', {
                eventCategory: 'entities',
                eventAction: 'play',
                eventLabel: id,
              })
            }
            return trackEvent('click entity', {
              eventCategory: 'entities',
              eventAction: 'click',
              eventLabel: id,
            })
          }

          return (
            <QueryTrackList
              datatesting="songlist"
              showCount={!!showCount}
              mode={compact ? 'extraCompact' : ''}
              key={String(index)}
              heading={isSmall && heading_mobile ? heading_mobile : heading}
              query={query}
              showMoreText={isSmall && show_more_text_mobile ? show_more_text_mobile : show_more_text}
              showMoreUrl={show_more_url}
              maxShown={max_shown}
              twoColumns={two_column}
              randomOrder={random_order}
              maxSize={max_size}
              onClick={handleClick}
            />
          )
        })}
      </div>
    </Section>
  )
}

export default TrackListsBlock
